import animation1 from "./animation1";
import animation2 from "./animation2";
import animation3 from "./animation3";
import animation4 from "./animation4";

export default [animation1, animation2, animation3, animation4];
